import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {change, clearFields, formValueSelector, getFormValues} from 'redux-form';
import { setCountries } from '../../../../../../redux/actions/app/ui/ui.actions';
import { getListCountries } from '../../../../../../redux/selectors/ui/ui.selectors';
import { getVehicule } from '../../../../../../redux/selectors/vehicule/vehicule.selectors';
import { getCRMAutoMin, getCRMMotoMin } from '@amo/core/utils/functions';
import Profil from './Profil';
import {
    getApporteur1Init,
    getCanalDemandeTarifInit,
    getSourceDemandeTarifInit
} from "../../../../../../redux/selectors/init/init.selectors.js";
import {dejaClientRefresh} from "../../../../../../redux/actions/app/dejaClient/dejaClient.actions.js";
import {getDejaClient} from "../../../../../../redux/selectors/dejaClient/dejaClient.selectors.js";
import _ from "lodash";
import {getToken} from "formulaire-direct/src/redux/selectors/init/init.selectors.js";

const mapStateToProps = (state) => {
    const selector = formValueSelector('devis');

    return {
        formValues: getFormValues('devis')(state),
        token: getToken(state),
        canal: getCanalDemandeTarifInit(state),
        apporteur: getApporteur1Init(state),
        source: getSourceDemandeTarifInit(state),
        civilitePrincipale: selector(state, 'civilitePrincipale'),
        conducteur: selector(state, 'DemandeTarif[ListePersonnes][0]'),
        permis: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis]'),
        permisOnError: selector(state, 'permisOnError'),
        phoneContactConsent: selector(state, 'DemandeDevis[PhoneContactConsent]'),
        emailContactConsent: selector(state, 'DemandeDevis[EmailContactConsent]'),
        typePermisAM: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][0][TypePermis]'),
        typePermisA1: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][1][TypePermis]'),
        typePermisA2: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][2][TypePermis]'),
        typePermisA: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][3][TypePermis]'),
        typePermisB: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][4][TypePermis]'),
        datePermisA2: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][2][DatePermis]'),
        datePermisA: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][3][DatePermis]'),
        datePermisB: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][4][DatePermis]'),
        dateNaissance: selector(state, 'DemandeTarif[ListePersonnes][0][DateNaissance]'),
        dateNaissanceRepresentant: selector(state, 'DemandeTarif[ListePersonnes][1][DateNaissance]'),
        conducteurMineur: selector(state, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'),
        cylindree: selector(state, 'cylindreeVehicule'),
        valeurCrmMoto: selector(state, 'DemandeTarif[ListePersonnes][0][ValeurCrmMoto]'),
        valeurCrmAuto: selector(state, 'DemandeTarif[ListePersonnes][0][ValeurCrmAuto]'),
        vehicule: getVehicule(state),
        cylindreeVehicule: selector(state, 'cylindreeVehicule'),
        titulaireCarteGrise: selector(state, 'titulaireCarteGrise'),
        familleProduit: selector(state, 'typeVehicule'),
        minCRMAuto: getCRMAutoMin(selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][4][DatePermis]')),
        vehiculeImmatricule: selector(state, 'DemandeTarif[Vehicule][VehiculeImmatricule]'),
        minCRMMoto: getCRMMotoMin({
            datePermisA1: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][1][DatePermis]'),
            datePermisA2: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][2][DatePermis]'),
            datePermisA: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][3][DatePermis]'),
            datePermisB: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][4][DatePermis]')
        }),
        birthCountryRepresentantLegal: selector(state, 'DemandeTarif[ListePersonnes][1][BirthCountry]'),
        countries: getListCountries(state),
        dejaClientData: getDejaClient(state),
        listePersonnes: selector(state, 'DemandeTarif[ListePersonnes]'),
        formation: selector(state, 'DemandeTarif[ListePersonnes][0][Formation]'),
        DeclarationAssurance: selector(state, 'DemandeTarif[ListePersonnes][0][DeclarationAssurance]'),
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    changeValue: (field, value) => change('devis', field, value),
    unsetValue: (field) => clearFields('devis', false, false, field),
    setCountries,
    dejaClientRefresh
},dispatch);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { familleProduit, dejaClientData, listePersonnes } = stateProps
    const { dejaClientRefresh } = dispatchProps

    return {
        ...ownProps, ...stateProps, ...dispatchProps,
        dejaClientRefresh: (dataOverride) => !_.isEmpty(dejaClientData) ? dejaClientRefresh({data: {typeProduit: familleProduit, listePersonnes: listePersonnes, ...dataOverride}, dejaClientData: dejaClientData}) : {},
    }
}

const ProfilContainer = compose(connect(mapStateToProps, mapDispatchToProps, mergeProps))(Profil);

export default ProfilContainer;
